import type { CityConfig } from "../city-template/types";

export const jeffersontownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Jeffersontown",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "jeffersontown",
  route: "/jeffersontown",
  title: "Emergency Passport Jeffersontown, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Jeffersontown, KY — as fast as 24 hours. Fast passport renewal and same-day help for J-Town, Bluegrass Industrial Park, and the Louisville East corridor. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Jeffersontown, KY",
  heroSubtitle: "Need an emergency passport fast from J-Town? Fast Passport Center helps Jeffersontown and Louisville East travelers get expedited passports as quickly as 24 hours. Serving the Bluegrass Industrial Park corridor, Eastpoint Business Center, and surrounding Jefferson County East communities. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Jeffersontown%20Kentucky%20suburban%20Louisville%20East%20commercial%20and%20residential%20district%2C%20clean%20modern%20suburban%20landscape%20with%20business%20parks%20and%20tree-lined%20streets%2C%20wide%20panoramic%20aerial%20view%20of%20eastern%20Jefferson%20County%20Kentucky%20community%2C%20bright%20daytime%20photography%2C%20no%20visible%20text%20or%20people&width=1800&height=700&seq=jeffersontown-hero-001&orientation=landscape",
  heroImageAlt: "Jeffersontown Kentucky suburban Louisville East commercial and residential district panoramic view",
  geoPosition: "38.1942;-85.5641",
  geoPlacename: "Jeffersontown, Kentucky",
  lastModified: "2026-05-29",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 310 miles from Jeffersontown via I-65",
  },
  nearbyCitiesZips: [
    { name: "Jeffersontown", zips: "40299, 40220, 40291" },
    { name: "Louisville East", zips: "40223, 40241, 40242, 40243, 40245" },
    { name: "Middletown", zips: "40243" },
    { name: "Fern Creek", zips: "40291" },
    { name: "Okolona", zips: "40228, 40229" },
    { name: "Buechel", zips: "40218" },
    { name: "St. Matthews", zips: "40207, 40220" },
    { name: "Anchorage", zips: "40223" },
    { name: "Lyndon", zips: "40222" },
    { name: "Hurstbourne", zips: "40220, 40222" },
    { name: "Jeffersontown Business Park", zips: "40299" },
    { name: "Shelbyville (nearby)", zips: "40065, 40066" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent J-Town departure needs" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your Jeffersontown case start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS drop in Jefferson County" },
  ],
  internalLinks: [
    { name: "Emergency passport services in Louisville", route: "/louisville" },
    { name: "Expedited passport renewal in Lexington", route: "/lexington" },
    { name: "Fast passport services in Shelbyville", route: "/shelbyville" },
    { name: "Same-day passport help in Frankfort", route: "/frankfort" },
    { name: "Urgent passport services in Georgetown", route: "/georgetown" },
    { name: "Emergency passport help in Elizabethtown", route: "/elizabethtown" },
  ],
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeNote: "Fast Passport Center serves Jeffersontown remotely via secure courier. We do not have a walk-in office in J-Town — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Jefferson County East travelers.",
  fpcOfficeDistance: "Serving all of Jeffersontown, Middletown, Fern Creek, and the Louisville East corridor",
  serviceAreaIntro: "From the Bluegrass Industrial Park to Eastpoint Business Center, from Middletown to Fern Creek — Fast Passport Center serves the entire Jeffersontown area and J-Town corridor of eastern Jefferson County.",
  nearbyCitiesIntro: "We serve all Jeffersontown neighborhoods and nearby communities including Middletown, Fern Creek, Okolona, Buechel, St. Matthews, Anchorage, Lyndon, Hurstbourne, and the greater Louisville East corridor. If you are in eastern Jefferson County, we have you covered.",
  howItWorksIntro: "Most Jeffersontown travelers complete everything online and ship documents overnight from the nearest UPS. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "J-Town travelers often underestimate how long passport processing takes. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Jeffersontown and Louisville East travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Jeffersontown? Here are the most common ones we hear from J-Town and Jefferson County East travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission slots",
        "Predictable turnaround for J-Town travelers",
        "Ideal for upcoming business or leisure travel",
        "Full document review included",
        "Dedicated agent assigned to your Jeffersontown case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns or postal delays",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service mail options",
        "Good for planned travel in the next few months",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Cannot upgrade speed after submission",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Medical crisis documentation required",
        "Long drive to Chicago — over 5 hours from J-Town",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For J-Town travelers with immediate departure needs — as fast as 24 hours for urgent Jefferson County East international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Jeffersontown adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with local acceptance clerk support for J-Town applicants.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency replacement for Jeffersontown residents with DS-64 form guidance and police documentation support.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors with parental consent and acceptance clerk support near Jeffersontown.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes for J-Town residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Jeffersontown", description: "Urgent 24-hour passport processing for Jeffersontown travelers with immediate international departure needs." },
    { name: "Passport Renewal Jeffersontown", description: "Fast passport renewal for Jeffersontown residents with passport issued in last 15 years at age 16 or older." },
    { name: "New Passport Jeffersontown", description: "First-time passport application assistance for Jeffersontown and J-Town Louisville East residents." },
    { name: "Lost Passport Replacement Jeffersontown", description: "Emergency passport replacement for lost or stolen passports in Jefferson County East." },
    { name: "Child Passport Jeffersontown", description: "Passport services for minors in Jeffersontown with parental consent and acceptance clerk support." },
    { name: "Name Change Passport Jeffersontown", description: "Passport name change after marriage, divorce, or legal name changes for Jeffersontown residents." },
  ],
  testimonials: [
    {
      name: "David K.",
      location: "Jeffersontown, KY",
      rating: 5,
      text: "Working at the Bluegrass Industrial Park, I had a last-minute business trip to Germany. My passport had expired two months earlier. Fast Passport Center renewed it in 4 days. The courier service is exactly what busy J-Town professionals need.",
      service: "Passport Renewal",
    },
    {
      name: "Sarah M.",
      location: "Middletown, KY",
      rating: 5,
      text: "Our family vacation to Cancun was booked and then I discovered my daughter's passport was expired. Fast Passport Center got her a new one in 5 days. Easy process, prepaid shipping label, and great communication throughout.",
      service: "Child Passport",
    },
    {
      name: "Thomas B.",
      location: "Jeffersontown, KY",
      rating: 5,
      text: "Lost my passport 6 days before a conference in London. Thought I would have to cancel the whole trip. Fast Passport Center processed an emergency replacement in 36 hours. Incredible service for J-Town business travelers.",
      service: "Lost Passport",
    },
    {
      name: "Linda R.",
      location: "Fern Creek, KY",
      rating: 5,
      text: "My husband and I were planning our 25th anniversary cruise to the Caribbean and realized his passport expired. Fast Passport Center renewed it in 5 days and we made our cruise from Miami. Professional, fast, and reliable.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "jeffersontown-1",
      name: "Jeffersontown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10420 Watterson Trail",
      city: "Jeffersontown",
      state: "KY",
      zip: "40299",
      phone: "(502) 266-1511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Main post office for J-Town residents",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Jeffersontown location. Appointments strongly recommended. Full passport acceptance services.",
      icon: "ri-mail-line",
    },
    {
      id: "jeffersontown-2",
      name: "Louisville St. Matthews Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4600 Shelbyville Rd",
      city: "Louisville",
      state: "KY",
      zip: "40207",
      phone: "(502) 895-1521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 7 miles from Jeffersontown center",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular alternative for J-Town residents. Photo services available on-site.",
      icon: "ri-mail-line",
    },
    {
      id: "jeffersontown-3",
      name: "Louisville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1420 W Liberty St",
      city: "Louisville",
      state: "KY",
      zip: "40203",
      phone: "(502) 582-1431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 12 miles from Jeffersontown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major Louisville facility. Good for Jeffersontown commuters. Call ahead to confirm passport slots.",
      icon: "ri-mail-line",
    },
    {
      id: "jeffersontown-4",
      name: "Shelbyville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 Main St",
      city: "Shelbyville",
      state: "KY",
      zip: "40065",
      phone: "(502) 633-1431",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 18 miles from Jeffersontown via I-64",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Good alternative if Jeffersontown PO is fully booked. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "jeffersontown-5",
      name: "Middletown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11915 Shelbyville Rd",
      city: "Louisville",
      state: "KY",
      zip: "40243",
      phone: "(502) 244-1521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 3 miles from Jeffersontown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient Middletown area facility. Close to Jeffersontown and Anchorage communities.",
      icon: "ri-mail-line",
    },
    {
      id: "jeffersontown-6",
      name: "Jefferson County Clerk — Main Office",
      type: "County Clerk Passport Acceptance",
      address: "527 W Jefferson St",
      city: "Louisville",
      state: "KY",
      zip: "40202",
      phone: "(502) 574-5130",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Approximately 13 miles from Jeffersontown",
      website: "https://jeffersonclerk.com/",
      websiteLabel: "Jefferson County Clerk",
      notes: "Full-service county clerk. Can process passport acceptance applications for Jefferson County residents.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, very limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day only for life-or-death emergencies", fpc: "24–48 hours for emergency, 3–5 days standard" },
    { feature: "Document Review", agency: "No — rejected documents sent back", fpc: "Yes — full review before submission" },
    { feature: "Travel Required", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or Jeffersontown UPS" },
    { feature: "Agent Support", agency: "Government clerk only, no follow-up", fpc: "Yes — dedicated J-Town agent assigned" },
    { feature: "Status Updates", agency: "No tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to appointment availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Non-Compliant Passport Photo",
      description: "Many J-Town photo shops produce generic ID photos. Passport photos must be exactly 2×2 inches with a plain white or off-white background — no shadows.",
    },
    {
      icon: "ri-file-list-line",
      title: "Wrong or Incomplete DS-11 Form",
      description: "Submitting a pre-signed DS-11 is the top rejection reason at Jefferson County East acceptance facilities. The clerk must witness your signature.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Fee Payment",
      description: "Passport fees change periodically. Jeffersontown applicants often arrive with wrong check amounts and must reschedule — adding days to their timeline.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Urgent Travel",
      description: "Without a confirmed flight itinerary, the Chicago agency won't grant an emergency appointment. Always have your booking ready to show.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent for Minors",
      description: "Both parents must appear or submit notarized DS-3053 consent. Many Jeffersontown families learn this the hard way at the acceptance clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long Before Applying",
      description: "Standard processing takes 8–11 weeks. Many J-Town travelers assume they have time. Start expedited at least 3 weeks before international travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes from anywhere in Jeffersontown." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We email you a prepaid overnight label. Drop your documents at any UPS location in J-Town or Louisville East." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the U.S. Department of State." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a State Department facility using our registered courier slots — no postal delays." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport to your Jeffersontown address — fully trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Jeffersontown, KY?", a: "Yes. Fast Passport Center provides emergency passport services for Jeffersontown and J-Town Louisville East travelers. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the long drive to Chicago." },
    { q: "How fast can I renew my passport near Jeffersontown?", a: "With Fast Passport Center, Jeffersontown travelers can get a passport renewed in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day option is the most popular. Both options include document review and a dedicated agent." },
    { q: "Where is the nearest passport acceptance facility to Jeffersontown?", a: "The most convenient options for J-Town residents are the Jeffersontown Post Office (10420 Watterson Trail), the Middletown Post Office on Shelbyville Road, and the St. Matthews Post Office (4600 Shelbyville Rd). All require appointments — we can help you find availability." },
    { q: "Do I need to drive to Chicago for an expedited passport from Jeffersontown?", a: "No. With Fast Passport Center, you complete everything online and ship your documents via prepaid overnight label. Our registered couriers handle the in-person delivery to State Department facilities in Chicago — you stay in J-Town and we do the rest." },
    { q: "Can I get a same-day passport from Jeffersontown?", a: "Same-day passports from the Chicago Regional Passport Agency are only for life-or-death emergencies — and require proof of travel within 72 hours plus a 5-hour drive. For nearly all J-Town urgent travel needs, our 24–48 hour emergency courier service is the best option." },
    { q: "How do I get a child passport in Jeffersontown, KY?", a: "For child passports in Jeffersontown, both parents must appear at an acceptance facility or submit notarized DS-3053 consent. We walk Jefferson County East families through the entire process, including appointment scheduling at the nearest facility." },
    { q: "What if I lost my passport before a trip from Jeffersontown?", a: "Contact Fast Passport Center immediately. We provide lost passport replacement services for Jeffersontown residents with DS-64 form guidance and emergency courier processing. We can get your replacement in 24–48 hours so you don't miss your departure." },
    { q: "How much does expedited passport service cost near Jeffersontown?", a: "Government fees are fixed: $130 for an adult passport book plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline and Jeffersontown pickup location." },
    { q: "What documents do I need for a first-time passport in Jeffersontown?", a: "You need proof of citizenship (birth certificate), government-issued photo ID, two passport photos, and payment. First-time applicants must visit an acceptance clerk in person. We provide a full checklist and review your documents before the clerk visit." },
    { q: "Is there a passport photo service near Jeffersontown?", a: "Yes — CVS at 9941 Taylorsville Rd, Walgreens on Bardstown Road, and FedEx Office on Hurstbourne Pkwy all offer passport photos near Jeffersontown. We review your photos before submission to ensure they meet State Department standards." },
    { q: "Can Jeffersontown business travelers use your service?", a: "Absolutely. Many of our J-Town clients work at Bluegrass Industrial Park and Eastpoint Business Center and travel internationally for business. We specialize in fast turnaround that accommodates professional schedules — complete everything online, ship overnight, receive your passport at your office or home." },
    { q: "How long does passport renewal take for Jeffersontown residents?", a: "With Fast Passport Center, Jeffersontown passport renewal takes 3–5 business days with our standard expedited option, or 24–48 hours with emergency processing. Standard government mail takes 8–11 weeks — not reliable for most J-Town travel timelines." },
    { q: "What is the fastest passport service available in Jeffersontown, KY?", a: "The fastest option is Fast Passport Center's 24–48 hour emergency courier service. We hand-deliver your documents directly to a U.S. Department of State processing facility, bypassing mail queues and postal delays that affect J-Town standard applications." },
    { q: "Can I use your service if my passport expires soon before a cruise?", a: "Yes. If your passport is expiring soon or already expired, contact us immediately. Cruise lines require your passport to be valid at least 6 months past your return date. We can expedite renewal for Jeffersontown residents in 24–48 hours — enough time for most upcoming cruises." },
    { q: "What neighborhoods near Jeffersontown do you serve?", a: "We serve all of Jeffersontown (J-Town) and the surrounding Louisville East communities including Middletown, Fern Creek, Okolona, Buechel, St. Matthews, Anchorage, Lyndon, Hurstbourne, and the Bluegrass Industrial Park corridor. All of Jefferson County East is covered." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Jeffersontown", address: "9941 Taylorsville Rd, Louisville, KY 40299", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Jeffersontown", address: "3600 Bardstown Rd, Louisville, KY 40218", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Hurstbourne", address: "9600 Preston Crossing Blvd, Louisville, KY 40229", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "Walmart — Middletown", address: "1600 Hurstbourne Pkwy, Louisville, KY 40220", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Middletown", address: "11601 Shelbyville Rd, Louisville, KY 40243", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — St. Matthews", address: "3500 Shelbyville Rd, Louisville, KY 40207", hours: "Mon–Sun: 8AM–10PM" },
  ],
  dmvLocations: [
    {
      name: "Jefferson County Circuit Court Clerk",
      address: "527 W Jefferson St, Louisville, KY 40202",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Main clerk office for Jefferson County. Handles REAL ID and driver's license renewals. Appointment recommended.",
      featured: true,
    },
    {
      name: "Jefferson County Clerk — Eastpoint Branch",
      address: "10400 Bunsen Way, Louisville, KY 40299",
      hours: "Mon–Fri: 8AM–4:00PM",
      note: "Eastpoint office convenient for J-Town residents. Walk-ins welcome for driver services.",
      featured: true,
    },
    {
      name: "Jefferson County Clerk — South Office",
      address: "3820 Valley Station Rd, Louisville, KY 40272",
      hours: "Mon–Fri: 8AM–4:00PM",
      note: "Alternative for Jeffersontown travelers on the south side of the county.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "20 miles from Jeffersontown",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "The primary airport for Jefferson County East travelers. Domestic flights with connections to major international hubs. Approximately 25 minutes from J-Town via I-264.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: true,
    },
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "78 miles from Jeffersontown",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "Alternative regional airport about 1.5 hours from J-Town via I-64. Good for flights to major hubs.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: false,
    },
    {
      code: "CVG",
      name: "Cincinnati/Northern Kentucky International",
      distance: "105 miles from Jeffersontown",
      address: "3087 Terminal Dr, Hebron, KY 41048",
      note: "Major international hub for long-haul flights. Accessible via I-71 from Jeffersontown.",
      flightUrl: "https://www.cvgairport.com/",
      flightLabel: "CVG Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Kentucky Office of Vital Statistics in Frankfort — order certified copies online, by mail, or in person for passport applications and name changes.", url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Jefferson County Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.jeffersoncountyclerk.org/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Jefferson Circuit Court Clerk — certified divorce decrees supporting passport name change or correction.", url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Jefferson.aspx" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Kentucky, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};